import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'timesheetActivitys'

/**
 *
 * @deprecated
 * use filter instead
 *
 */
const getAll = (axios: IFactoryFunctionRequest<any, any>) => (): IFactoryResponse<Array<any>, any> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
  })
}

const filter = (axios: IFactoryFunctionRequest<any, any>) => (query): IFactoryResponse<Array<any>, any> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query
  })
}

const create = (axios: IFactoryFunctionRequest<any, any>) => (data) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<any, any>) => (id, { data }) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${id}`,
    data,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest<any, any>) => (id) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  filter: filter(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
})
